export const environment = {
    production          : true,
    hmr                 : false,
    test                : false,

    appPrefix           : 'artp-',
    enableThemeEdit     : false,
    baseFrontendUrl     : 'https://portal.artstuff.vn',
    baseApiUrl          : '',
    openid              : {
        redirectUri         : 'https://portal.artstuff.vn/auth-callback',
        clientId            : 'artstuff-frontend',
        scope               : 'profile email',
        issuer              : 'https://id.portal.artstuff.vn/auth/realms/Artstuff-Enterpise'
    },

};
